export default function ScreenReaderDropDownInstructions() {
  return (
    <div className="sr-only">
      <h3>Election Pamaters</h3> change options to update data table below
    </div>
  );
}
